export const ISLOGGEDIN_COOKIE = "isLoggedIn";

export const SUPPORT_WIDGET_HIDDEN_ROUTES = [
    "/financing",
    "/financing/",
    "/checkout/select-offer",
    "/checkout/select-offer/",
    "/price/communication"
];
